import { Controller } from '@hotwired/stimulus'
import { on, off } from '../lib/events'
import { put } from '../lib/request'

const URL = '/admin/products'

export default class extends Controller {
  static values = {
    uuid: String,
    id: Number,
    errors: Boolean,
  }

  static targets = [
    'progressBar',
  ]

  connect = () => {
    on(this.uuidValue, this.handleEvent)
  }

  disconnect = () => {
    off(this.uuidValue, this.handleEvent)
  }

  handleEvent = (event) => {
    if (event.detail.progress) {
      return this.updateFileProgress(event.detail.file)
    }
    else if (event.detail.complete) {
      off(this.uuidValue, this.handleEvent)

      return this.updateProduct(event.detail.file.signedId)
    }
  }

  updateFileProgress = (file) => {
    if (this.hasProgressBarTarget) {
      this.progressBarTarget.style.width = `${file.progress}%`
    }
  }

  updateProduct = (signedId) => {
    const params = {
      print_product: {
        asset: signedId,
      },
    }

    return put(`${URL}/${this.idValue}`, {
      responseKind: 'json',
      body: JSON.stringify(params),
    })
  }
}
